import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { orderBy } from 'lodash';

import {
  Toggle,
  ToggleType,
  Statistics,
  StatisticsType,
  Tool,
} from '../../models';

interface Header {
  title: string;
  prop: string;
  timestamp?: boolean;
  filter?: boolean;
  clickable?: boolean;
  size?: 'big' | 'double' | 'small' | 'half';
  only?: Tool;
}

@Component({
  selector: 'app-statistics-table',
  templateUrl: './statistics-table.component.html',
  styleUrls: ['./statistics-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticsTableComponent implements OnInit {
  private _statistics: Statistics[] = [];
  @Input() set statistics(statistics: Statistics[]) {
    this._statistics = statistics;
    this.filteredStatistics = orderBy(statistics, [this.orderBy], ['desc']);
  }
  get statistics() {
    return this._statistics;
  }

  @Input() sticky: Header = {
    title: 'Domain',
    prop: 'domain',
    size: 'double',
    filter: true,
  };
  @Input() orderBy = 'sent';
  @Input() extraHeaders: Header[] = [];
  @Input() toggleText: string;
  @Input() toggles: Toggle[];
  @Input() header = 'Top sent domains';
  @Input() type = StatisticsType.DOMAINS;
  @Input() showDownloadButton = true;
  @Input() headers: Header[] = [
    { title: 'Sent', prop: 'sent' },
    { title: 'Delivered', prop: 'normalizedDelivered' },
    { title: 'Delivery rate', prop: 'deliveryRate' },
    { title: 'Bounced', prop: 'uniqueBounce' },
    { title: 'Bounce rate', prop: 'bounceRate' },
    { title: 'Opens', prop: 'open' },
    { title: 'Unique opens', prop: 'uniqueOpen' },
    { title: 'Open rate', prop: 'openRate' },
    { title: 'Clicks', prop: 'click' },
    { title: 'Unique clicks', prop: 'uniqueClick' },
    { title: 'Click rate', prop: 'clickRate' },
    { title: 'CTO', prop: 'clickToOpenRate' },
    { title: 'Unsubscribes', prop: 'unsubscribe' },
    { title: 'Unique unsubscribes', prop: 'uniqueUnsubscribe' },
    { title: 'Unsubscribe rate', prop: 'unsubscribeRate' },
    { title: 'Spam complaints', prop: 'uniqueAbuse' },
    { title: 'Spam complaint rate', prop: 'abuseRate' },
  ];

  @Output() rowClick = new EventEmitter<Statistics>();
  @Output() toggleClick = new EventEmitter<boolean>();
  @Output() toggleClick1 = new EventEmitter<{
    type: ToggleType;
    selected: boolean;
  }>();
  @Output() toggleClick2 = new EventEmitter<{
    type: ToggleType;
    selected: boolean;
  }>();
  @Output() downloadClick = new EventEmitter<StatisticsType>();

  public ToggleType = ToggleType;
  filterBy = '';
  filterProps: string[] = [];
  filteredStatistics: Statistics[] = [];
  desc = true;

  ngOnInit() {
    this.filterProps = [this.sticky, ...this.headers, ...this.extraHeaders]
      .filter((header) => header.filter)
      .map((header) => header.prop);
  }

  filter(value: string) {
    this.filterBy = value;
    this.sortAndFilter();
  }

  sort(prop: string) {
    if (this.orderBy === prop) {
      this.desc = !this.desc;
    }
    this.orderBy = prop;
    this.sortAndFilter();
  }

  onRowClick(statistics: Statistics) {
    if (window.getSelection().type !== 'Range') {
      this.rowClick.emit(statistics);
    }
  }

  sortAndFilter() {
    const filter = new RegExp(this.filterBy, 'i');

    this.filteredStatistics = this.statistics.filter((stats) =>
      this.filterProps.some((prop) => filter.test(stats[prop])),
    );

    this.filteredStatistics = orderBy(
      this.filteredStatistics,
      [this.orderBy],
      [this.desc ? 'desc' : 'asc'],
    );
  }
}
